import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { Button } from '@ontruck/orc';
import VehicleList from 'components/VehicleList';
import style from './style.module.scss';
import useCarriersLite from 'utils/hooks/useCarriersLite';

const Vehicles = ({ intl, vehicles, onNewVehicle, onEditVehicle, allowNew = true }) => {
  const t = intl.messages.components.CarrierDetails;
  const { isEditVehicleDisabled, isVehicleWidthHidden } = useCarriersLite();
  return (
    <div className={style.section}>
      <div className={style.sectionHeader}>
        <h2 className={style.sectionTitle}>{t.vehicles_title}</h2>

        {!isEditVehicleDisabled && (
          <Button
            ghost
            skin="primary"
            icon="plus"
            iconPosition="left"
            size="M"
            className={style.addVehicleButton}
            onClick={onNewVehicle}
            disabled={!allowNew}
          >
            {t.vehicles_add}
          </Button>
        )}
      </div>

      <VehicleList
        vehicles={vehicles}
        onEditVehicle={onEditVehicle}
        isVehicleWidthHidden={isVehicleWidthHidden}
        t={t.vehicle_list}
      />
    </div>
  );
};

Vehicles.propTypes = {
  intl: PropTypes.any,
  vehicles: PropTypes.array,
  onNewVehicle: PropTypes.func,
  onEditVehicle: PropTypes.func,
  allowNew: PropTypes.bool,
};

export default injectIntl(Vehicles);
